export default __webpack_public_path__ + "static/media/select-radio-empty.47bf126c.svg";